// import { take, call, put, select } from 'redux-saga/effects';

// Individual exports for testing
export default function* customerSaga() {
  // See example in containers/HomePage/saga.js
}
